<template>
	<div class="container">
		<h2>Expressions of Interest</h2>
		<v-row>
			<v-col>
				<v-card class="d-flex pa-2" flat outlined>
					<span class="mx-2"><strong>Filters</strong></span>
					<v-divider vertical class="mx-2"></v-divider>
					<a
						@click="filter = ''"
						class="mx-2"
						:style="
							filter !== '' ? 'color: grey' : 'color: #86ae41'
						"
					>
						None
					</a>
					<a
						@click="filter = 'Last Week'"
						class="mx-2"
						:style="
							filter !== 'Last Week'
								? 'color: grey'
								: 'color: #86ae41'
						"
					>
						Last Week
					</a>
					<a
						@click="filter = 'Not Viewed'"
						class="mx-2"
						:style="
							filter !== 'Not Viewed'
								? 'color: grey'
								: 'color: #86ae41'
						"
					>
						Not Viewed
					</a>
				</v-card>
			</v-col>
		</v-row>
		<p v-show="filteredInterest.length === 0">
			Looks like there's nothing here.
		</p>
		<div v-for="interest in filteredInterest" :key="interest.expressionId">
			<interestCard :data="interest" />
		</div>
	</div>
</template>

<script>
import interestCard from "@/components/Seller Components/interestCard.vue";

import { mapState } from "vuex";

export default {
	name: "ViewInterest",
	metaInfo() {
		return {
			title: "IP-BID.com - View Expressed Interest"
		};
	},
	components: {
		interestCard
	},
	data() {
		return {
			filter: ""
		};
	},
	created() {
		this.$store.dispatch("retrieveInterestList");
	},
	computed: {
		...mapState(["seller"]),
		filteredInterest() {
			const daysAgo = days => {
				return new Date().getTime() - 1000 * 60 * 60 * 24 * days;
			};

			switch (this.filter) {
				case "":
					return this.seller.interestList;
				case "Not Viewed":
					return this.seller.interestList.filter(
						interest => !interest.viewedByInsolvency
					);
				case "Last Week":
					return this.seller.interestList.filter(
						interest =>
							Date.parse(interest.createdDate) > daysAgo(7)
					);
				default:
					return this.seller.interestList;
			}
		}
	}
};
</script>
